<template>
  <li class="profile-nav onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        src="../../assets/images/dashboard/profile.jpg"
        alt=""
      />
      <div class="media-body">
        <span>{{ name }}</span>
        <p class="mb-0 font-roboto">
          {{ current_company }}<i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <!-- <li>
        <a href="#"><feather type="user"></feather><span>Account </span></a>
      </li>
      <li>
        <a href="#"></a>
        <Language />
      </li> -->
      <!--<li>
        <a href="#"><feather type="mail"></feather><span>Inbox</span></a>
      </li>
      <li>
        <a href="#"
          ><feather type="file-text"></feather><span>Taskboard</span></a
        >
      </li>
      <li>
        <a href="#"><feather type="settings"></feather><span>Settings</span></a>
      </li>-->
      <li>
        <a @click="logout"
          ><feather type="log-in"></feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>
  import { PublicClientApplication } from '@azure/msal-browser';
  import UserAuth from '../../pages/auth/js/index';
  import Language from './language';
  import { msal_config } from '../../constants/service';
  import { auth_host } from '../../constants/service';
  export default {
    name: 'Profile',
    components: {
      Language,
    },
    data() {
      return {
        name: '',
        current_company: '',
        currnet_role: '',
        $msalInstance: {},
        accounts: [],
      };
    },
    created() {
      this.$msalInstance = new PublicClientApplication(msal_config);
    },

    mounted() {
      this.set_name();
      const accounts = this.$msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        this.account = accounts[0];
      }
    },
    methods: {
      set_name: function () {
        var user_data = JSON.parse(localStorage.getItem('userinfo'));
        this.name = user_data.firstname.replace(':', ' ');
        // ' ' + user_data.lastname;
        this.current_company = user_data.email;
      },
      async logout() {

        let userinfo = localStorage.getItem('userinfo');
        var userInfo = JSON.parse(userinfo);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json',
                        'Authorization': 'Bearer '+userInfo.access_token },
            //body: JSON.stringify({ email })
        };
        var url = auth_host + `/api/logout`;
        fetch(url, requestOptions);


        const logoutRequest = {
          account: this.$msalInstance.getAccountByUsername(this.username),
          postLogoutRedirectUri: msal_config.auth.redirectUri,
          // mainWindowRedirectUri: msal_config.auth.redirectUri,
        };
        await this.$msalInstance
          .logoutPopup(logoutRequest)
          .then(() => {
            // console.log('sign out success');
            UserAuth.Logout();
            this.$router.push('/login').catch();
          })
          .catch((error) => {
            console.error(error);
            // console.log('sign out err', error);
          });
      },
    },
  };
</script>
